<script lang="ts">
import { schedule } from '../../store';
import Show from '../Show.svelte';
import { onDestroy } from 'svelte';
import { pevent } from '../../analytics';
import { type Session } from '../../services';

const PaddingMin = 30;

export let id;
export let sectionTitle;

let isPast;
let session: Session;
let error;
let timer;

onDestroy(() => {
  clearInterval(timer);
  document.removeEventListener('visibilitychange', writeDuration);
})

function startHeartbeat() {
  clearInterval(timer);
  timer = setInterval(() => {
    pevent('session', 'view', id, 20, '', false)
  }, 20_000)
}

function writeDuration() {
  if (document.visibilityState === 'hidden') {
    clearInterval(timer);
  } else {
    startHeartbeat();
  }
}

async function loadShow(id) {
  try {
    // loading = true;
    session = $schedule.find(s => s.id === id);
    // session = {
    //   id: 'c86b41e1-bc3b-4af1-8bd9-06abef5e42a0',
    //   name: 'This is a long title for the sake of long titles CHINA',
    //   reactions: true,
    //   description: 'the description',
    //   questionChannel: 'sendbird_open_channel_8736_a3d34df737dcf06b8fe700a0bc608bedf31a5997',
    //   chatChannel: 'sendbird_open_channel_8736_770ad2ea52f67e259674367a4110ba6a69c1ac58',
    //   liveStream: '',
    //   start: new Date(),
    //   end: new Date(Date.now() + 3213123),
    // }

    if (!session) {
      error = "Show not found";
      return;
    }

    isPast = session.end.getTime() + (60000 * PaddingMin) <= Date.now();
    if (isPast && !session.replayStream) {
      error = "Show has ended";
      return;
    }

    document.removeEventListener('visibilitychange', writeDuration);
    document.addEventListener('visibilitychange', writeDuration);
    startHeartbeat();
  } catch (e) {
    console.error(e)
    error = "Unable to load specified show";
  } finally {
    // loading = false;
  }
}
$: if ($schedule) loadShow(id)
</script>

{#if session}
  <Show {session} {sectionTitle} {isPast} />
{:else if error}
  {error}
{/if}